import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { TypeEvent } from '../models/type-event';
import 'rxjs/add/operator/map';

@Injectable()
export class TypeEventService {

  private typeEventUrl: string = `${ environment.apiRoot }/event-type/`;

  constructor(private http: HttpAuth) { }

  public getTypeEvent(): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });
    return this.http.get(this.typeEventUrl)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getTypeEventList(page?: number, pagecount?: number, query?: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '5');
    }

    if (query) {
        params.set('query', query);
    }
    params.set('list', '1');
    const options = new RequestOptions({search: params});

    return this.http.get(this.typeEventUrl, options)
    // return this.http.get(this.typeEventUrl+"?list=1", options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putTypeEvent(typeEvent:TypeEvent): Observable<TypeEvent> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.put(this.typeEventUrl,typeEvent,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postTypeEvent(typeEvent:TypeEvent): Observable<TypeEvent> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(this.typeEventUrl,typeEvent,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deleteTypeEvent(typeEventID): Observable<TypeEvent> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey,
      'id': typeEventID
    });

    return this.http.delete(this.typeEventUrl+"?id="+typeEventID,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/type-event.service.ts